import React from 'react';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import BackSubheader from '../../elements/BackSubheader';
import ItemAddedFeedback from '../../elements/cart/ItemAddedFeedback';
import Styles from '../../Styles';
import {
  Dimensions,
  Keyboard,
  Modal,
  Platform,
  ScrollView,
  StyleSheet,
  Pressable,
  View,
} from 'react-native';
import UIManager from '../../elements/ui/UIManager';
import NavActions from 'src/actions/NavActions';
import ScreenContext from '../../ScreenContext';
import Localized from 'src/constants/AppStrings';
import AVText from '../../elements/AVText';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import {isValidEmail} from 'src/services/ValidatorService';
import KeyboardAvoidingView from '../../elements/365KeyboardAvoidingView';
import StickerList from '../../elements/sendSnack/StickerList';
import AccountStore from 'src/stores/AccountStore';
import Util, {getPreviousRouteName} from 'src/Util';
import AppRoutes from 'src/AppRoutes';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppDispatch, RootState} from 'src/redux/store';
import {
  sendSnackToUser,
  SendSnackToUserParams,
} from '../../../redux/thunks/snackThunks';
import {NavigationProp} from '@react-navigation/native';
import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import Settings from 'src/Settings';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import CustomTextInput from 'src/components/elements/CustomTextInput';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {getDescriber as getRoundedButtonViewStyle} from 'src/components/screens/orderAhead/descriptor/DescriptorType';

import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type SendSnackScreenProp = WithGlobalizeProps & {
  sendSnackToUser(params: SendSnackToUserParams): {
    [index: string]: number | string | {[index: string]: string | number};
  };
  navigation?: NavigationProp<SendSnackScreen>;
  displayBalances?: number;
};
type SendSnackScreenState = {
  amount: string;
  description: string;
  email: string;
  isPrivate: boolean;
  stickerId: number;
  amountError?: string;
  mailError?: string;
  isSnackDataValid: boolean;
  isGiftTextInputFocused: boolean;
  previousRoute: string;
  showSuccessMdl?: boolean;
  contentHeight?: number;
  receiverName?: string;
  sentAmount?: number;
};

const dollarSymbol = '$';
const screenWidth = Dimensions.get('window').width;
const multipler = Platform.OS === 'web' ? 0.3 : 0.85;
const modalWidth = screenWidth * multipler;

const {getPickupLocationStyles, getInactiveButtonColor} =
  getRoundedButtonViewStyle();

class SendSnackScreen extends React.Component<
  SendSnackScreenProp,
  SendSnackScreenState
> {
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;

  constructor(props) {
    super(props);
    this.state = {
      amount: '',
      description: '',
      email: '',
      isPrivate: false,
      stickerId: 0,
      amountError: '',
      mailError: '',
      isSnackDataValid: false,
      isGiftTextInputFocused: false,
      previousRoute: '',
      showSuccessMdl: false,
      contentHeight: 0,
      receiverName: '',
      sentAmount: 0,
    };
    this.onBackSelect = this.onBackSelect.bind(this);
    this.getRightView = this.getRightView.bind(this);
    this.getBalanceContainer = this.getBalanceContainer.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.onChangeGiftAmount = this.onChangeGiftAmount.bind(this);
    this.validateGiftAmount = this.validateGiftAmount.bind(this);
    this.onSendSnack = this.onSendSnack.bind(this);
    this.validateSnackData = this.validateSnackData.bind(this);
    this.handleSnackBalanceCovers = this.handleSnackBalanceCovers.bind(this);
    this.navigateToFunding = this.navigateToFunding.bind(this);
    this.onContactSelected = this.onContactSelected.bind(this);
    this.getGiftAmountTextValue = this.getGiftAmountTextValue.bind(this);
    this.checkErrorMessage = this.checkErrorMessage.bind(this);
    this.checkDesktopBgColor = this.checkDesktopBgColor.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.handleContentLayout = this.handleContentLayout.bind(this);
  }

  componentDidMount(): void {
    const previousRoute = getPreviousRouteName(
      this.props.navigation.getState()?.routes,
    );
    this.setState({previousRoute});
  }

  getBalanceContainer(smallText: boolean) {
    return UIManager.getBalanceContainer(smallText, Localized);
  }

  getRightView() {
    if (Platform.OS === 'web') {
      return null;
    } else {
      return (
        <View style={!Settings.isNewUI && styles.rightContainer}>
          {this.getBalanceContainer(false)}
        </View>
      );
    }
  }

  onBackSelect() {
    NavActions.pop();
  }

  onChangeEmail(email: string) {
    FirebaseAnalytic.trackEvent('onChangeEmail', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      email,
    });
    this.setState({
      email,
      mailError: undefined,
    });
    this.validateSnackData(
      Number(this.state.amount),
      email,
      this.state.stickerId,
    );
  }

  validateEmail() {
    if (isValidEmail(this.state.email)) {
      this.setState({
        mailError: undefined,
      });
    } else {
      this.setState({
        mailError: Localized.Errors.please_enter_the_valid_email,
      });
    }
  }

  onChangeGiftAmount(amount: string) {
    amount = amount.replace(dollarSymbol, '');
    FirebaseAnalytic.trackEvent('onChangeGiftAmount', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      amount,
    });
    if (!amount || amount.match(/^\d{1,}(\.\d{0,2})?$/)) {
      this.setState(
        {
          amount,
          amountError: undefined,
        },
        () => {
          // Clear amount error if amount is empty
          if (!amount) {
            this.setState({
              amountError: undefined,
            });
          } else {
            // Check if amount is valid and set error if needed
            const amountValue = Number(amount);
            if (amountValue < 1.0 && amountValue >= 0) {
              this.setState({
                amountError: Localized.Errors.minimum_snack_gift_amount,
              });
            }
          }
          this.validateSnackData(
            Number(this.state.amount),
            this.state.email,
            this.state.stickerId,
          );
        },
      );
    }
  }

  validateGiftAmount() {
    FirebaseAnalytic.trackEvent('validateGiftAmount', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
    });
    this.setState({
      isGiftTextInputFocused: false,
    });
    const amountValue = Number(this.state.amount);

    if (amountValue >= 1.0) {
      this.setState({
        amount: amountValue.toFixed(2).toString(),
        amountError: undefined,
      });
    } else {
      this.setState({
        amountError: Localized.Errors.minimum_snack_gift_amount,
      });
    }

    // Ensure isSnackDataValid is always in sync
    this.validateSnackData(amountValue, this.state.email, this.state.stickerId);
  }

  getGiftAmountTextValue() {
    FirebaseAnalytic.trackEvent('getGiftAmountTextValue', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
    });
    if (this.state.amount === '' && this.state.isGiftTextInputFocused) {
      return dollarSymbol;
    } else if (this.state.amount === '') {
      return '';
    } else {
      return dollarSymbol + this.state.amount;
    }
  }
  handleContentLayout = (event) => {
    const {height} = event.nativeEvent.layout;

    this.setState({
      contentHeight: height,
    });
  };
  onContactSelected(email: string) {
    FirebaseAnalytic.trackEvent('onContactSelected', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      email,
    });
    this.setState({
      email,
    });

    if (isValidEmail(email)) {
      this.setState({
        mailError: undefined,
      });
    } else {
      this.setState({
        mailError: Localized.Errors.please_enter_the_valid_email,
      });
    }

    this.validateSnackData(
      Number(this.state.amount),
      email,
      this.state.stickerId,
    );
  }

  validateSnackData(amount: number, email: string, stickerId: number) {
    const validData =
      isValidEmail(email) && Number(amount) >= 1.0 && stickerId === 0;

    FirebaseAnalytic.trackEvent('validateSnackData', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      validData,
      email,
      stickerId,
    });

    this.setState({
      isSnackDataValid: validData,
    });
  }

  canteenStickers() {
    return (
      <>
        <AVText
          accessible={true}
          accessibilityLabel={Localized.Labels.choose_a_sticker}
          accessibilityRole="text"
          aria-label={`${Localized.Labels.choose_a_sticker}, text`}
          style={styles.chooseStickerLabel}
        >
          {Localized.Labels.choose_a_sticker}
        </AVText>
        <StickerList
          size={Styles.Heights.h8}
          onStickerSelection={(id) => {
            this.setState({
              stickerId: id,
            });
            this.validateSnackData(
              Number(this.state.amount),
              this.state.email,
              id,
            );
          }}
        />
      </>
    );
  }
  handleSnackBalanceCovers() {
    const transDate = Util.getCurrentDate();
    if (
      this.state.email.toLowerCase() === AccountStore.getEmail().toLowerCase()
    ) {
      this.setState({
        mailError:
          Localized.Errors.oops +
          ' ' +
          Localized.Errors.you_cannot_snack_to_yourself.substring(
            0,
            Localized.Errors.you_cannot_snack_to_yourself.length - 1,
          ) +
          '.',
        isSnackDataValid: false,
      });
      return;
    }

    const snackAmount = Number(this.state.amount);

    // Validate minimum amount before proceeding
    if (snackAmount < 1.0) {
      this.setState({
        amountError: Localized.Errors.minimum_snack_gift_amount,
        isSnackDataValid: false,
      });
      return;
    }

    const balance = this.props.displayBalances ?? 0;
    const amountDue = snackAmount - balance;
    FirebaseAnalytic.trackEvent('handleSnackBalanceCovers', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      transDate,
      snackAmount,
      balance,
      amountDue,
    });
    if (amountDue > 0) {
      this.navigateToFunding(amountDue, transDate);
    } else {
      this.onSendSnack(transDate);
    }
  }

  navigateToFunding(balance: number, transDate: string) {
    FirebaseAnalytic.trackEvent('navigateToFunding', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      transDate,
      balance,
    });
    this.context.actions.navigateToFunding(true, {
      transDate,
      remainingDue: balance,
      isSnackGiftDue: true,
      addFundsSuccess: () => this.onSendSnack(transDate),
    });
  }

  yourMsgLbl() {
    return Util.secondLetterCapitalize('Your Message');
  }

  giftAmtLbl() {
    return Util.secondLetterCapitalize(Localized.Labels.gift_amount);
  }

  checkErrorMessage() {
    return Localized.Errors.not_registed_snack_error_365;
  }
  renderModal = (): React.ReactNode => {
    return (
      <Modal
        visible={this.state.showSuccessMdl}
        onDismiss={this.hideModal}
        transparent={true}
      >
        <View style={styles.deleteAcntModalMain}>
          <View
            style={[
              styles.deleteAcntModalContainer,
              {height: this.state.contentHeight + 180},
            ]}
          >
            <AVTouchableOpacity
              aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
              role="button"
              style={styles.closeModalTitleContainer}
              onPress={this.hideModal}
              accessible
              accessibilityLabel={Localized.Buttons.cancel}
              accessibilityRole="button"
              testID="qa_ClosePopup_btn"
              nativeID="qa_ClosePopup_btn"
              hitSlop={Styles.HitSlop_10}
            >
              <CancelIcon />
            </AVTouchableOpacity>
            <View
              style={styles.deleteAcntModalContentContainer}
              onLayout={this.handleContentLayout}
            >
              <AVText
                aria-label={`${Localized.Success.success} label, text`}
                accessibilityLabel={`${Localized.Success.success} label`}
                style={[
                  styles.modalLablestye,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                accessible={true}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                testID="qa_PopupTitle_txt"
                nativeID="qa_PopupTitle_txt"
              >
                {Localized.Success.success}
              </AVText>
              <AVText
                accessible={true}
                accessibilityLabel={`${Localized.Success.delete_acnt_desc} label`}
                aria-label={`${Localized.Success.delete_acnt_desc} label, text`}
                style={[
                  styles.successText,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                numberOfLines={2}
                testID="qa_PopupMessage_txt"
                nativeID="qa_PopupMessage_txt"
              >
                {
                  Localized.Success.formatString(
                    Localized.Success.snack_sent_success,
                    this.state.sentAmount?.toFixed(2).toString(),
                    this.state.receiverName,
                  ) as string
                }
              </AVText>
            </View>

            <View>
              <RoundedAppButton
                buttonType={RoundedAppButtonType.Solid}
                onPress={() => this.hideModal()}
                buttonViewStyle={styles.roundedBtnViewStyle}
                buttonContainerStyle={{
                  alignSelf: 'center',
                }}
                accessibilityLabelValue={`${Localized.Buttons.snack_btn_txt}`}
                titleText={Localized.Buttons.snack_btn_txt}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                textStyle={[
                  styles.snackBtnTextStyle,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                testID="qa_SendAnotherSnack_btn"
              />
              <RoundedAppButton
                buttonType={RoundedAppButtonType.Outline}
                onPress={() =>
                  this.setState(
                    {
                      showSuccessMdl: false,
                      receiverName: '',
                      sentAmount: 0,
                    },
                    () => {
                      NavActions.pop();
                    },
                  )
                }
                buttonViewStyle={styles.modalRoundedBtntyle}
                buttonContainerStyle={styles.takeHomeBtnContainer}
                accessibilityLabelValue={`${Localized.Buttons.takemeHome}`}
                titleText={Localized.Buttons.takemeHome}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                textStyle={[
                  styles.takeHomeBtnText,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                testID="qa_TakeMeHome_btn"
              />
            </View>
          </View>
        </View>
      </Modal>
    );
  };
  hideModal = () => {
    this.setState({
      showSuccessMdl: false,
      receiverName: '',
      sentAmount: 0,
    });
  };
  async onSendSnack(transDate: string) {
    Keyboard.dismiss();
    FirebaseAnalytic.trackEvent('onSendSnack', 'SendSnackScreen', {
      ...this.props,
      ...this.state,
      transDate,
    });

    // Additional validation check before API call
    const snackAmount = Number(this.state.amount);
    if (snackAmount < 1.0) {
      this.setState({
        amountError: Localized.Errors.minimum_snack_gift_amount,
        isSnackDataValid: false,
      });
      return;
    }

    try {
      const data = await this.props.sendSnackToUser({
        locationId: AccountStore.getLocationId(),
        amount: Number(this.state.amount),
        description: this.state.description,
        email: this.state.email,
        isPrivate: this.state.isPrivate,
        stickerId: this.state.stickerId,
        transDate: transDate,
        context: this.context,
      });
      const payload =
        typeof data.payload === 'object' && data.payload !== null
          ? data.payload
          : {};
      const meta =
        typeof data.meta === 'object' && data.meta !== null ? data.meta : {};
      if (payload && payload.responseCode === 404) {
        this.setState({
          mailError: String(payload.responseMsg)
            .toLowerCase()
            .includes('this person cannot receive snacks')
            ? this.checkErrorMessage()
            : Localized.Errors.not_enabled_snack,
          isSnackDataValid: false,
        });
      }
      if (
        payload &&
        meta &&
        Object.keys(meta).length > 0 &&
        meta.requestStatus === 'fulfilled' &&
        !payload.responseCode
      ) {
        this.setState({
          amount: '',
          description: '',
          email: '',
          isPrivate: false,
          stickerId: 0,
          amountError: '',
          mailError: '',
          isSnackDataValid: false,
          isGiftTextInputFocused: false,
          showSuccessMdl: true,
          receiverName: String(payload.receiverName),
          sentAmount: Number(payload.amount),
        });
      }
    } catch (error) {

    }
  }

  checkDesktopBgColor = () => {
    return Platform.OS === 'web'
      ? Styles.Colors.PayNew.neutralHuesBase11
      : null;
  };

  render() {
    const content = (
      <KeyboardAvoidingView behavior="height" insideTab>
        <ScrollView
          keyboardDismissMode="interactive"
          automaticallyAdjustContentInsets={false}
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={
            getSnackDescriber().getSendSnackStyleDescriptor().scrollViewContent
          }
        >
          <View
            style={[
              styles.content,
              Styles.Style.maxWidthContainer,
              {paddingTop: Styles.Spacing.m4},
            ]}
          >
            {
              <>
                <View style={styles.snackText}>
                  <View
                    style={styles.flexView}
                    accessible
                    testID="qa_YourBalanceValue_txt"
                    nativeID="qa_YourBalanceValue_txt"
                  >
                    <AVText
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                      style={[
                        styles.payYourBalance,
                        getSnackDescriber().snackDetailsBtnFontSTyle(),
                      ]}
                      adjustsFontSizeToFit
                      numberOfLines={1}
                    >
                      {`${Localized.Labels.your_balance}: `}
                      <AVFormattedCurrency
                        testID={'balanceFormattedCurrency'}
                        accessibilityLabel={
                          this.props.displayBalances
                            ? `$${this.props.displayBalances.toString()}`
                            : '0'
                        }
                        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                        style={[
                          styles.payYourBalance,
                          getSnackDescriber().snackDetailsBtnFontSTyle(),
                        ]}
                        value={this.props.displayBalances ?? 0}
                        currency={AccountStore.getCurrency()}
                      />
                    </AVText>
                  </View>
                  <View style={styles.refillBtnView}>
                    <Pressable
                      style={[styles.refillBal]}
                      onPress={() => {
                        FirebaseAnalytic.trackEvent(
                          'refillBalance',
                          'SendSnackScreen',
                          {
                            ...this.props,
                            ...this.state,
                            transDate: Util.getCurrentDate(),
                          },
                        );
                        this.context.actions.navigateToFunding(true, {
                          transDate: Util.getCurrentDate(),
                        });
                      }}
                      role="button"
                      nativeID={Localized.Labels.refill_bal}
                      accessibilityLabel={Localized.Labels.refill_bal}
                      aria-label={Localized.Labels.refill_bal}
                      accessibilityRole="button"
                    >
                      <AVText
                        style={[
                          styles.refillBalbtnStyle,
                          getSnackDescriber().snackDetailsBtnFontSTyle(),
                        ]}
                        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                        adjustsFontSizeToFit={true}
                      >
                        {Localized.Labels.refill_bal}
                      </AVText>
                    </Pressable>
                  </View>
                </View>

                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  style={[
                    styles.paySendSnackDescription,
                    getSnackDescriber().snackDetailsBtnFontSTyle(),
                  ]}
                >
                  {`${Localized.Labels.send_snack_description}`}
                </AVText>

                <CustomTextInput
                  label={Util.secondLetterCapitalize(
                    Localized.Labels.email_address,
                  )}
                  value={this.state.email}
                  autoCapitalize="none"
                  keyboardType="email-address"
                  onBlur={() => this.validateEmail()}
                  returnKeyType="next"
                  maxLength={75}
                  accessible={true}
                  accessibilityLabel="Email"
                  aria-label="Email"
                  onChangeText={this.onChangeEmail}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  showShadow={true}
                  textColor={'#111'}
                  fontSize={Styles.Fonts.f7}
                  hasErrorMsg={this.state.mailError ? true : false}
                  errorMsg={this.state.mailError}
                  errorTextStyle={styles.errorTextStyle}
                  textStyle={styles.errorTextHeight}
                  outlineStyle={
                    this.state.mailError
                      ? {
                          borderColor: Styles.Colors.PayNew.error,
                          borderWidth: 1.5,
                        }
                      : {}
                  }
                  labelStyle={[
                    styles.emailLabel,
                    getSnackDescriber().snackDetailsBtnFontSTyle(),
                  ]}
                  testID="qa_fld_Email"
                  errorMsgTestId="qa_emailError_txt"
                />

                <View
                  style={[
                    styles.contactContainer,
                    styles.emailRevolveSpacing,
                    this.state.mailError ? {marginTop: 13} : {marginTop: 8},
                  ]}
                >
                  <RoundedButton
                    role="button"
                    maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                    buttonType={ButtonType.outline}
                    text={Localized.Labels.choose_from_contacts}
                    disabled={Platform.OS === 'web'}
                    containerStyle={[
                      styles.button,
                      styles.chooseContactBtnRevolve,
                      {borderWidth: 2},
                    ]}
                    backgroundColor={
                      Platform.OS !== 'web'
                        ? 'white'
                        : this.checkDesktopBgColor()
                    }
                    accessible={true}
                    textStyle={[
                      styles.chooseContactBtnText,
                      getSnackDescriber().snackDetailsBtnFontSTyle(),
                    ]}
                    accessibilityLabel="Choose from contacts"
                    testID="qa_btn_ChooseContacts"
                    onPress={() => {
                      NavActions.navigate(AppRoutes.ChooseContact, {
                        onContactSelect: (email) => {
                          this.onContactSelected(email);
                        },
                      });
                    }}
                    accessibilityRole="button"
                    color={scanAndPayTemplate.primaryColor}
                    aria-label="Choose from contacts"
                  />
                </View>
              </>
            }
            <View style={styles.giftAmountView}>
              <CustomTextInput
                label={this.giftAmtLbl()}
                value={this.getGiftAmountTextValue()}
                autoCapitalize="none"
                maxLength={10}
                accessible={true}
                accessibilityLabel={this.giftAmtLbl()}
                accessibilityValue={{text: this.getGiftAmountTextValue()}}
                aria-label={this.giftAmtLbl()}
                aria-valuetext={this.getGiftAmountTextValue()}
                onChangeText={(e) =>
                  this.onChangeGiftAmount(e.replace(',', '.'))
                }
                keyboardType={Platform.OS === 'web' ? 'default' : 'numeric'}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                returnKeyType="next"
                clearButtonMode="while-editing"
                textColor={Styles.black}
                onBlur={() => this.validateGiftAmount()}
                fontSize={Styles.Fonts.f7}
                outlineStyle={
                  this.state.amountError
                    ? {
                        borderColor: Styles.Colors.PayNew.error,
                        borderWidth: 1.5,
                      }
                    : {}
                }
                textStyle={styles.giftAmountTextHeight}
                labelStyle={[
                  styles.giftAmountLable,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                showShadow={true}
                hasErrorMsg={this.state.amountError ? true : false}
                errorMsg={this.state.amountError}
                errorTextStyle={styles.giftAmountErrorTextStyle}
                testID="qa_fld_GiftAmount"
                errorMsgTestId="qa_giftAmountError_txt"
              />
            </View>
            <View
              style={styles.msgLableView}
              accessible
              testID="qa_fld_YourMessage"
              nativeID="qa_fld_YourMessage"
            >
              <CustomTextInput
                autoCapitalize="none"
                accessible={true}
                label={this.yourMsgLbl()}
                accessibilityLabel={this.yourMsgLbl()}
                accessibilityValue={{text: this.state.description}}
                aria-label={this.yourMsgLbl()}
                aria-valuetext={this.state.description}
                value={this.state.description}
                multiline={true}
                numberOfLines={5}
                onChangeText={(e) => {
                  this.setState({
                    description: e,
                  });
                }}
                maxLength={140}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                returnKeyType="next"
                containerStyle={[
                  getSnackDescriber().snackMessageContainerStyle(),
                ]}
                contentStyle={[
                  getSnackDescriber().snackMessageContentStyle(),
                  styles.msgContentStyle,
                ]}
                clearButtonMode="while-editing"
                textColor={'#111'}
                fontSize={Styles.Fonts.f7}
                labelStyle={[
                  styles.msgLableViewTextStyle,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                showShadow={true}
              />

              <AVText
                style={[
                  styles.payDescriptionCountLabel,
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
              >
                {this.state.description.length + '/140'}
              </AVText>
            </View>
          </View>
        </ScrollView>
        <View style={getPickupLocationStyles().buttonContainerStyle}>
          <RoundedAppButton
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            buttonType={RoundedAppButtonType.Solid}
            inActiveButtonViewStyle={[
              getPickupLocationStyles().buttonView,
              {
                backgroundColor: getInactiveButtonColor(),
              },
            ]}
            buttonViewStyle={[
              getPickupLocationStyles().buttonView,
              {
                backgroundColor: scanAndPayTemplate.primaryColor,
              },
            ]}
            onPress={this.handleSnackBalanceCovers}
            isDisabled={!this.state.isSnackDataValid}
            accessibilityLabelValue="Send Snack"
            aria-label="Send Snack"
            titleText={Util.secondLetterCapitalize(
              Localized.Buttons.send_snack,
            )}
            textStyle={[
              styles.paySnackBtn,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
            buttonContainerStyle={getPickupLocationStyles().containerStyle}
            testID="qa_btn_SendSnack"
          />
        </View>
      </KeyboardAvoidingView>
    );
    return (
      <BackSubheader
        title={Localized.Labels.send_a_snack_title}
        testId={'qa_SendSnack.PageTitle_txt'}
        accessibilityLabel="Back arrow"
        accessibilityHint={`Press to navigate back to the ${this.state.previousRoute} screen`}
        onBackSelect={this.onBackSelect}
        pop={false}
      >
        {content}
        <ItemAddedFeedback
          strings={Localized}
          extraMargin={Styles.Spacing.m0}
        />
        <>{this.state.showSuccessMdl && this.renderModal()}</>
      </BackSubheader>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    paddingHorizontal: Settings.isNewUI()
      ? Styles.Spacing.m3 + Styles.Spacing.m2
      : Styles.Spacing.m3,
    paddingTop: Styles.Spacing.m1,
  },
  rightContainer: {
    alignItems: 'flex-end',
    flex: 1,
    justifyContent: 'space-between',
    paddingTop: Styles.Spacing.m4,
  },
  msgContentStyle: {
    paddingBottom: Styles.Spacing.m1,
    paddingTop: Styles.Spacing.m2,
  },
  errorLabel: {
    color: Styles.dangerColor,
    fontSize: getLayoutDescriber().bodyFontSize(),
    alignSelf: 'flex-start',
  },
  descriptionCountLabel: {
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f0,
    alignSelf: 'flex-end',
  },
  payDescriptionCountLabel: {
    color: '#707070',
    fontSize: getLayoutDescriber().bodyFontSize(),
    alignSelf: 'flex-end',
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
    marginTop: Styles.Spacing.m1,
    marginRight: Styles.Spacing.m3,
  },
  textField: {
    marginTop: Styles.Spacing.m2,
    alignSelf: 'stretch',
    height: Styles.Heights.h3,
  },
  button: {
    alignSelf: 'flex-end',
    marginEnd: Styles.Spacing.m1,
  },
  privateStatusContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    alignItems: 'center',
    padding: Styles.Spacing.m2,
  },
  privateLabel: {
    color: Styles.lightGray,
    fontSize: getLayoutDescriber().bodyFontSize(),
    marginRight: Styles.Spacing.m2,
  },
  chooseStickerLabel: {
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f0,
    marginTop: Styles.Spacing.m2,
  },
  contactContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: Styles.Spacing.m3,
    alignItems: 'center',
  },
  toLabel: {
    fontWeight: 'bold',
    marginRight: Styles.Spacing.m1,
  },
  yourBalance: {
    color: Styles.black,
    fontWeight: 'bold',
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    position: 'relative',
    width: '100%',
    height: 40,
  },
  sendSnackDescription: {
    color: Styles.black,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '600',
    position: 'relative',
    width: 295,
    height: 34,
    top: 10,
  },
  chooseContactTxtRevolve: {
    fontSize: getLayoutDescriber().bodySmallFontSize(),
    fontWeight: '700',
    color: Styles.darkGreenRevolve,
  },
  chooseContactBtnRevolve: {
    borderRadius: Styles.Spacing.m4,
    borderWidth: 1,
    paddingVertical: Styles.Spacing.m2 + 4,
    paddingHorizontal: Styles.Spacing.m2 + 7,
    marginTop: 10,
  },
  emailRevolveSpacing: {
    marginLeft: 'auto',
    marginTop: Styles.Spacing.m1 - 10,
    marginBottom: 8,
  },
  inputTextStyles: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '500',
    color: Styles.black,
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  paySnackBtn: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  paySnackBtncontainer: {
    left: undefined,
  },
  payLblStyle: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  paySendSnackDescription: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  payYourBalance: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '700',
    fontFamily: scanAndPayTemplate.textFontFamily,
    color: '#111',
    position: 'relative',
    width: '100%',
    paddingVertical: 4,
  },
  refillBal: {
    alignItems: 'center',
    borderWidth: 1.2,
    borderRightColor: scanAndPayTemplate.primaryColor,
    borderRadius: Styles.Spacing.m4,
    borderBottomColor: scanAndPayTemplate.primaryColor,
    paddingVertical: Styles.Spacing.m2,
    borderTopColor: scanAndPayTemplate.primaryColor,
    borderLeftColor: scanAndPayTemplate.primaryColor,
    paddingHorizontal: Styles.Spacing.m3,
    overflow: 'hidden',
    backgroundColor: '#fff',
    minHeight: Styles.MinTouchableArea,
    justifyContent: 'center',
  },
  refillBalbtnStyle: {
    fontSize: getLayoutDescriber().bodySmallFontSize(),
    fontWeight: Platform.OS === 'android' ? 'bold' : '700',
    color: scanAndPayTemplate.snackRoundedBtnTextColor,
    textTransform: 'capitalize',
  },
  deleteAcntModalMain: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  deleteAcntModalContainer: {
    width: modalWidth,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: 12,
  },
  deleteAcntModalContentContainer: {
    marginTop: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  deleteAcntTitle: {
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontWeight: '700',
    color: '#111',
    fontFamily: scanAndPayTemplate.textFontFamily,
    textAlign: 'center',
  },
  deleteAcntDesc: {
    paddingTop: 16,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    color: '#111',
    fontFamily: scanAndPayTemplate.textFontFamily,
    textAlign: 'center',
    paddingBottom: 25,
  },
  btndelete: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: '#fff',
    fontFamily: scanAndPayTemplate.textFontFamily,
    textAlign: 'center',
  },
  btndeleteTakeMe: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: scanAndPayTemplate.snackBorderColor,
    fontFamily: scanAndPayTemplate.textFontFamily,
    textAlign: 'center',
    paddingHorizontal: 24,
  },
  closeModalTitleContainer: {
    justifyContent: 'flex-end',
    position: 'absolute',
    top: Styles.Heights.h1 + 4,
    right: Styles.Heights.h1 + 4,
  },
  roundedBtnViewStyle: {
    overflow: 'hidden',
    borderRadius: 32,
    backgroundColor: scanAndPayTemplate.snackBorderColor,
    borderTopColor: scanAndPayTemplate.snackBorderColor,
    borderBottomColor: scanAndPayTemplate.snackBorderColor,
    borderLeftColor: scanAndPayTemplate.snackBorderColor,
    borderRightColor: scanAndPayTemplate.snackBorderColor,
    borderColor: scanAndPayTemplate.snackBorderColor,
    paddingHorizontal: 24,
    paddingVertical: 10,
  },
  modalRoundedBtntyle: {
    overflow: 'hidden',
    borderWidth: 2,
    borderRadius: 32,
    borderTopColor: scanAndPayTemplate.snackBorderColor,
    borderBottomColor: scanAndPayTemplate.snackBorderColor,
    borderLeftColor: scanAndPayTemplate.snackBorderColor,
    borderRightColor: scanAndPayTemplate.snackBorderColor,
    borderColor: scanAndPayTemplate.snackBorderColor,
    paddingHorizontal: 42,
    paddingVertical: 10,
  },
  modalLablestye: {
    color: '#111',
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '700',
    paddingBottom: 8,
  },
  successText: {
    color: '#111',
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    textAlign: 'center',
    paddingBottom: 24,
  },
  snackBtnTextStyle: {
    color: Styles.white,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    textAlign: 'center',
    textTransform: 'none',
  },
  takeHomeBtnText: {
    fontWeight: '700',
    fontSize: getLayoutDescriber().bodyFontSize(),
    color: scanAndPayTemplate.snackBorderColor,
  },
  takeHomeBtnContainer: {
    alignSelf: 'center',
    marginTop: 13,
  },
  refilView: {
    alignSelf: 'flex-end',
    top: -18,
  },
  errorTextStyle: {
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: getLayoutDescriber().bodyFontSize(),
    alignContent: 'flex-start',
    alignSelf: 'flex-start',
  },
  errorTextHeight: {
    height: 60,
  },
  emailLabel: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontWeight: '400',
    color: '#707070',
  },
  chooseContactBtnText: {
    fontSize: getLayoutDescriber().bodySmallFontSize(),
    fontWeight: '700',
    color:
      Platform.OS == 'web'
        ? '#707070'
        : scanAndPayTemplate.snackRoundedBtnTextColor,
  },
  giftAmountView: {marginBottom: 10},
  giftAmountTextHeight: {
    height: 60,
  },
  giftAmountLable: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '400',
    color: '#707070',
  },
  giftAmountErrorTextStyle: {
    fontWeight: '400',
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: getLayoutDescriber().bodyFontSize(),
    alignContent: 'flex-start',
    alignSelf: 'flex-start',
  },
  msgLableView: {marginTop: Styles.Spacing.m1 - 11},
  msgLableViewTextStyle: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    color: '#707070',
  },
  snackText: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: Styles.Spacing.m4,
  },
  refillBtnView: {
    flex: 0.45,
    alignItems: 'flex-end',
    marginRight: Styles.Spacing.m2,
  },
  flexView: {flex: 0.6},
});

const mapStateToProps = (state: RootState) => ({
  displayBalances: state.account.account.defaultBalance?.balance,
});

export default compose(
  withForwardedNavigationParams(),
  withGlobalize,
  connect(mapStateToProps, (dispatch: AppDispatch) => ({
    sendSnackToUser: (params) => dispatch(sendSnackToUser(params)),
  })),
)(SendSnackScreen);
